import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import { FormControl } from "@mui/material";
import { useUpdateQuickPaymentMutation } from "Api/Mutations/User/useUpdateQuickPaymentMutation";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Pages.Content.BankAccounts;

type Props = {
  // Quick payment is a user-level feature — any currency's primary enables it
  // (the debited account is resolved per transaction currency at pay time).
  hasPrimaryAccount: boolean;
};

export const QuickPaymentSection = ({ hasPrimaryAccount }: Props) => {
  const { mutate: updateQuickPayment } = useUpdateQuickPaymentMutation();
  const { data: userInfo, isLoading: isUserInfoLoading } = useUserInfoQuery();
  const { t } = useResource();

  return (
    <FormControl fullWidth>
      <FormControlLabel
        control={
          <Checkbox
            checked={userInfo?.isQuickPaymentEnabled ?? false}
            onChange={(e) =>
              updateQuickPayment({ isEnabled: e.target.checked })
            }
            disabled={!hasPrimaryAccount || isUserInfoLoading}
          />
        }
        label={t(PageResources.QuickPayment.Label)}
      />
      <Typography display="flex" alignItems="flex-start" mt={1} gap={1}>
        <InfoOutlinedIcon sx={{ height: "1rem", width: "1rem", mt: 0.5 }} />
        {t(PageResources.QuickPayment.Description)}
      </Typography>
    </FormControl>
  );
};
